import FileInput from '../../components/FileInput';

export default class CustomReviews {
    private fileInput = new FileInput('review_form', ['image/jpeg', 'image/png']);
    private successClasses = ['bg-green-700', 'text-white', 'mt-5', 'px-4', 'py-2', 'text-sm', 'rounded', 'shadow-md', 'overflow-hidden'];
    private inputErrorClasses = ['error'];
    private errorPopupClasses = ['error-popup', 'bg-red-700', 'text-white', 'mt-5', 'px-4', 'py-2', 'text-sm', 'rounded', 'shadow-md', 'overflow-hidden'];
    private form = document.querySelector('#review_form') as HTMLFormElement;
    private inputs = {
        name: this.form.querySelector('[name="display_name"]') as HTMLInputElement,
        content: this.form.querySelector('[name="review_content"]') as HTMLTextAreaElement,
        score: this.form.querySelector('[name="custom_score"]') as HTMLSelectElement,
    }

    constructor() {
        this.addHoverEventToStars();
        this.addTextAreaEvent();
        this.addSubmitEvent();
    }

    private addTextAreaEvent() {
        this.inputs.content.addEventListener('input', this.handleTextAreaInput);
    }

    private handleTextAreaInput = (event: Event) => {

        const target = event.target as HTMLTextAreaElement;
        const value = target.value;
        const length = value.length;
        const counter = this.form.querySelector('.counter') as HTMLSpanElement;
        counter.textContent = length.toString();

        if (length >= 1000) {
            target.classList.add(...this.inputErrorClasses);
            counter.classList.add(...['text-red-700', 'font-bold']);
        } else {
            target.classList.remove(...this.inputErrorClasses);
            counter.classList.remove(...['text-red-700', 'font-bold']);
        }
    }

    private addHoverEventToStars() {
        this.form.querySelectorAll('.custom-score .star').forEach((star) => {
            star.addEventListener('mouseover', this.handleStarHover);
            star.addEventListener('mouseout', this.handleStarHover);
            star.addEventListener('click', this.handleStarClick);
        })
    }

    private handleStarHover = (event: Event) => {
        const star = event.target as HTMLButtonElement;
        const starRating = star.dataset.rating as string;
        const starRatingNumber = parseInt(starRating) as number;
        if (event.type === 'mouseover') {
            this.handleStarHoverIn(starRatingNumber);
        } else {
            this.handleStarHoverOut();
        }
    }

    private handleStarHoverIn = (starRatingNumber: number) => {
        const stars = document.querySelectorAll('.star') as NodeListOf<HTMLButtonElement>;
        stars.forEach((star) => {
            const starRating = parseInt(star.dataset.rating as any) as number;
            if (starRating <= starRatingNumber) {
                star.classList.add('hover');
            }
        })
    }

    private handleStarHoverOut = () => {
        const stars = document.querySelectorAll('.star');
        stars.forEach((star) => {
            star.classList.remove('hover');
        })
    }

    private handleStarClick = (event: Event) => {
        const target = event.target as HTMLButtonElement;
        const starRating = parseInt(target.dataset.rating as string) as number;
        this.inputs.score.value = starRating.toString();

        const stars = this.form.querySelectorAll('.star') as NodeListOf<HTMLButtonElement>;
        stars.forEach((star) => {
            const starRatingNumber = parseInt(star.dataset.rating as any) as number;
            if (starRatingNumber <= starRating) {
                star.classList.add('selected');
            } else {
                star.classList.remove('selected');
            }
        })
    }

    private addSubmitEvent() {
        this.form.addEventListener('submit', this.handleSubmit);
    }

    private handleSubmit = (event: Event) => {
        event.preventDefault();
        this.deleteErrorPopupIfExists();
        const form = event.target as HTMLFormElement;
        const formData = new FormData(form);
        formData.append('action', 'create_review');
        formData.append('nonce', window.app_extra.nonce);

        // add files from list instead of input
        const files = Object.entries(this.fileInput.getFileList());
        for (let i = 0; i < files.length; i++) {
            formData.append("files[]", files[i][1]);
        }
        const submitButton = this.form.querySelector('.submit') as HTMLButtonElement;
        if (this.valdateForm()) {
            submitButton.classList.add('loading');
            this.submitReview(formData);
        }
    }

    private submitReview = async (formData: FormData) => {
        const res = await fetch(window.app_extra.ajaxUrl, {
            method: 'POST',
            body: formData,
        });
        const data = await res.json();
        if (data.success) {
            this.handleSuccess(data.data);
        } else {
            this.handleError(data.data);
        }
    }

    private handleSuccess = (data: any) => {
        const successMessage = document.createElement('div') as HTMLDivElement;
        successMessage.textContent = data.message;
        successMessage.classList.add(...this.successClasses);
        this.form.parentNode?.appendChild(successMessage);
        this.form.remove();
        setTimeout(() => {
            successMessage.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }, 300);
    }

    private deleteErrorPopupIfExists = () => {
        const errorPopup = this.form.querySelector('.error-popup');
        if (errorPopup) {
            errorPopup.remove();
        }
    }

    private handleError = (data: any) => {
        const submitButton = this.form.querySelector('.submit') as HTMLButtonElement;
        submitButton.classList.remove('loading');
        const errorPopup = this.createErrorPopup(data.message);
        this.form?.appendChild(errorPopup);
        setTimeout(() => {
            errorPopup.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }, 300);
    }

    private createErrorPopup = (message: string) => {
        const errorPopup = document.createElement('div') as HTMLDivElement;
        errorPopup.classList.add(...this.errorPopupClasses);
        errorPopup.textContent = message;
        return errorPopup;
    }

    private addErrorClassesToInput = (field: any) => {
        field.classList.add(...this.inputErrorClasses);
    }

    private resetValidationMessages = () => {
        const errors = this.form.querySelectorAll('.error');
        errors?.forEach((error) => {
            error.classList.remove(...this.inputErrorClasses);
        })
    }

   
    private valdateForm = () => {
        this.resetValidationMessages();
        let returnState = true;

        if (!this.inputs.name.value) {
            returnState = false;
            this.addErrorClassesToInput(this.inputs.name);
        }
        if (this.inputs.content.value.length > 1000 || this.inputs.content.value.length < 1) {
            returnState = false;
            this.addErrorClassesToInput(this.inputs.content);
        }
        return returnState;
    }
}